import PropTypes from "prop-types"

const ScoreShape = {
  scoreValue: PropTypes.int,
  scoreType: PropTypes.int,
  percentage: PropTypes.number,
}
export default ScoreShape



// WEBPACK FOOTER //
// ./src/state/shapes/ScoreShape.js